module.exports = __webpack_public_path__ + "img/comission_desktop.9bf970f1.svg";